import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ManageSocialLogin from "./manageSocialLogin";
import ResetPassword from "./ResetPassword";
import { getUserAuthDetails } from "../../../redux/auth/authActions";

export default function ManageLogin() {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getUserAuthDetails());
  }, [dispatch]);

  return (
    <div className="sm:w-[820px] w-full mt-10 sm:ml-10 sm:mt-0 px-4 sm:px-6 pb-10 bg-white dark:bg-[#121212] sm:min-h-[1000px] rounded-sm shadow-lg">
      <div className="border-b-2 py-4 sm:py-6 mb-6 flex sm:block justify-between items-center">
        <p className="text-base font-medium text-gray-800 dark:text-white text-center">
          Manage Login
        </p>
      </div>
      <ManageSocialLogin />
      <ResetPassword />
    </div>
  );
}
